import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import {
  NuclearTopicsDistrEnriched,
  NUCLEAR_TOPICS_EXPLANATION,
  GraphTopic,
} from '../../../../models/ai-model';
import { Chart, registerables } from 'chart.js';
import { NuclearTopicsLabelService } from '../../../../services/label.nucleartopics.service';

@Component({
  selector: 'app-interview-ai-nuclear-topic',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './interview-ai-nuclear-topic.component.html',
  styleUrl: './interview-ai-nuclear-topic.component.scss',
})
export class InterviewAiNuclearTopicComponent
  implements OnChanges, AfterViewInit
{
  @ViewChild('chart') chartElement: ElementRef<HTMLCanvasElement> | undefined;
  @Input() nuclearTopicsDistrEnriched: NuclearTopicsDistrEnriched = {
    date: '',
    title: '',
    categories_distribution_available: false,
    categories_distribution: null,
  };
  @Input() isLoading: boolean = false;

  chart: Chart | undefined;
  nuclearTopicsExplanation: GraphTopic[] = NUCLEAR_TOPICS_EXPLANATION;
  nuclearTopicsLabels: { [key: string]: string } = {};

  constructor(private nuclearTopicsLabelService: NuclearTopicsLabelService) {
    this.nuclearTopicsLabels = this.nuclearTopicsLabelService.getTopicLabels();
    Chart.register(...registerables);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.nuclearTopicsDistrEnriched.categories_distribution_available) {
      setTimeout(() => {
        if (this.chartElement) {
          this.prepareCategoriesDistributionGraph();
        }
      });
    }
  }

  ngAfterViewInit(): void {
    // Use setTimeout to ensure the chart is created after the DOM has rendered
    setTimeout(() => {
      this.prepareCategoriesDistributionGraph();
    });
  }

  prepareCategoriesDistributionGraph() {
    if (this.chart) {
      this.chart.destroy(); // Destroy the previous chart if it exists
    }

    const nuclearTopicsDistr =
      this.nuclearTopicsDistrEnriched.categories_distribution;
    if (nuclearTopicsDistr) {
      const labels = Object.keys(nuclearTopicsDistr).map((key) =>
        this.formatCategoryLabel(key)
      );
      const data = Object.values(nuclearTopicsDistr);

      if (this.chartElement) {
        const chartWidth = 700;
        this.chartElement.nativeElement.style.width = `${chartWidth}px`;
        const ctx = this.chartElement.nativeElement.getContext('2d');
        if (ctx) {
          this.chart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: labels,
              datasets: [
                {
                  label: 'Values',
                  data: data,
                  backgroundColor: 'rgba(75, 192, 192, 0.2)',
                  borderColor: 'rgba(75, 192, 192, 1)',
                  borderWidth: 1,
                },
              ],
            },
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                  max: 100, // Imposta l'intervallo da 0 a 100 poiché la somma è sempre 100
                },
              },
              plugins: {
                legend: {
                  display: false, // Nascondi la label "Values"
                },
              },
            },
          });
        }
      }
    }
  }

  formatCategoryLabel(key: string): string {
    return this.nuclearTopicsLabels[key];
  }
}
